import { dynamicImage, Image } from "../../../Utils";

const PageImage = () => {
  return (
    <ul className="page-decore">
      <li className="top">
        <Image className="img-fluid inner2" src={dynamicImage("landing/footer/2.png")} alt="footer-back-img" />
      </li>
      <li className="bottom">
        <Image className="img-fluid inner2" src={dynamicImage("landing/footer/2.png")} alt="footer-back-img" />
      </li>
    </ul>
  );
};

export default PageImage;
